export default "__VITE_ASSET__a4b03a1b__"